import { type SWRConfiguration } from 'swr'

// TODO: 네트워크 문제가 생길시, 500대 에러일시 retry(onErrorRetry옵션)를 시도할려고 했으나, swr 사용시에 suspense를 사용하면 retry기능이 지원안됨
// 커스텀하여 구현하는방법은 https://swr.vercel.app/docs/middleware 미들웨어로 가능
export const swrConfig: SWRConfiguration = {
	suspense: true,
	shouldRetryOnError: false,
	revalidateOnFocus: false,
}
